import type { Datalayer, GDDLEvent } from '@analytics/models';
import { inject, Injectable } from '@angular/core';
import { tap, type Observable } from 'rxjs';

import { DATALAYER_STREAM_SIDE_EFFECTS } from './provide-datalayer-side-effects';

@Injectable({
  providedIn: 'root',
})
export class SideEffectsManager {
  readonly #sideEffects =
    inject(DATALAYER_STREAM_SIDE_EFFECTS, {
      optional: true,
    }) ?? [];

  /**
   * Applies all registered side effects to the event stream.
   * @param datalayer reference to the datalayer which will be provided to all side effects.
   * @returns A function to apply side effects within an RxJS pipeline.
   */
  applySideEffects(datalayer: Datalayer) {
    return (event$: Observable<GDDLEvent>): Observable<GDDLEvent> => {
      // Apply side effects to the stream using `tap`
      return event$.pipe(
        tap((event) => {
          this.#sideEffects.forEach((sideEffect) => {
            sideEffect.process(event, datalayer);
          });
        })
      );
    };
  }
}
